import { FormattedMessage } from 'react-intl'
import Card from '../shared/Card'
import PaymentIconsRow from './PaymentIconsRow'
import styles from './ReserveNowPayLaterStrip.module.scss'

const ICON_BASE = `${window.staticPath}travel_dist/images/payment_icons`

export default function ReserveNowPayLaterStrip() {
  return (
    <Card className={styles.card}>
      <div className={styles.leftSection}>
        <img
          className={styles.leftIcon}
          src={`${ICON_BASE}/shield-check.svg`}
          alt=''
          aria-hidden='true'
        />
        <div className={styles.leftText}>
          <span className={styles.leftTitle}>
            <FormattedMessage
              id='reserve_now_pay_later'
              defaultMessage='RESERVE NOW, PAY LATER'
            />
          </span>
          <span className={styles.leftDesc}>
            <FormattedMessage
              id='reserve_spot_zero_obligations'
              defaultMessage='Reserve your spot with zero obligations'
            />
            <br />
            <FormattedMessage
              id='no_payment_details_now'
              defaultMessage='No need to enter payment details now!'
            />
          </span>
        </div>
      </div>
      <div className={styles.rightSection}>
        <span className={styles.paymentOptionsLabel}>
          <img
            className={styles.creditCardIcon}
            src={`${ICON_BASE}/credit-card.svg`}
            alt=''
            aria-hidden='true'
          />
          <FormattedMessage
            id='payment_options'
            defaultMessage='PAYMENT OPTIONS'
          />
        </span>
        <PaymentIconsRow />
      </div>
    </Card>
  )
}
